

export const NOT_SET_VALUES = [undefined, '', null]; // sorted by most probable
